import type { SkeletonProps } from "@/v2-ui/skeleton/Skeleton"
import Skeleton from "@/v2-ui/skeleton/Skeleton"

export type LineLoaderProps = SkeletonProps & {
  isLoading: boolean
}

function LineLoader(props: LineLoaderProps) {
  const { isLoading, children, ...divProps } = props

  if (isLoading) {
    return <Skeleton {...divProps} />
  }

  return <div {...divProps}>{children}</div>
}

export default LineLoader
